import onResize from '../utils/onResize'
import emitter from '../utils/emitter'
import { get, getAll } from '@bigyouth/base'
import withResponsive from '../hoc/withResponsive'

export default withResponsive({
  name: 'toggle-content',

  ui: {
    button: '[js-toggle-content-button]',
    button2: '[js-toggle-content-button2]',
    close: '[js-toggle-content-close]',
    content: '[js-toggle-content-content]',
    innerContent: '[js-toggle-content-inner]',
  },

  events: [
    {
      target: 'button',
      on: 'click',
      handle ({ target }) {
        this.openPanel()

        if (this.ui.content.getAttribute('js-sr-inactive') !== null) {
          this.ui.content.removeAttribute('js-sr-inactive')
        } else {
          this.ui.content.setAttribute('js-sr-inactive', '')
        }
      },
    },
  ],

  componentDidMount () {
    this.off = onResize(this.onResize.bind(this))

    if (this.ui.button2) {
      this.ui.button2.addEventListener('click', () => {
        this.openPanel()

        if (this.ui.content.getAttribute('js-sr-inactive') !== null) {
          this.ui.content.removeAttribute('js-sr-inactive')
        } else {
          this.ui.content.setAttribute('js-sr-inactive', '')
        }
      })
    }

    if (this.props && this.props.isOpen) {
      if (this.props && this.props.isSection) {
        this.ui.content.style.height = 'auto'
        setTimeout(() => {
          this.ui.content.style.height = `${this.ui.innerContent.offsetHeight}px`
        }, 1000)
      } else {
        this.ui.content.style.height = `${this.ui.innerContent.offsetHeight}px`
      }
    }

    if (this.props && this.props.isSection) {
      emitter.on('subsectionResizing', (datas) => {
        if (this.el.id === datas.parentId) {
          let height = this.ui.innerContent.offsetHeight
          height = datas.open
            ? height + datas.subsectionHeight
            : height - datas.subsectionHeight

          this.ui.content.style.height = `${height}px`
        }
      })
    }
  },

  componentWillUnmount () {
    this.off()
  },

  onResize () {
    if (this.ui.content.classList.contains('is-visible')) {
      if (this.props && this.props.isSection) {
        setTimeout(() => {
          const height = this.ui.innerContent.offsetHeight
          this.ui.content.style.height = `${height}px`
        }, 1000)
      } else {
        const height = this.ui.innerContent.offsetHeight
        this.ui.content.style.height = `${height}px`
      }
    }
  },

  openPanel () {
    // if connected accordions
    if (this.props && this.props.connected) {
      const activePanel = get(
        '[js-toggle-content-content].is-visible',
        this.el.parentNode,
      )
      const activeButton = get(
        '[js-toggle-content-button].is-active',
        this.el.parentNode,
      )

      if (activePanel && activePanel !== this.ui.content) {
        this.closePanel(activePanel, activeButton)
      }
    }

    this.ui.button.classList.toggle('is-active')
    this.ui.content.classList.toggle('is-visible')

    if (this.ui.content.classList.contains('is-visible')) {
      const height = this.ui.innerContent.offsetHeight
      this.ui.content.style.height = `${height}px`

      setTimeout(() => {
        this.ui.content.classList.add('has-overflow')
      }, 300)
    } else {
      this.ui.content.style.height = 0
      this.ui.content.classList.remove('has-overflow')

      if (this.props && this.props.scrollUp) {
        this.scrollUp()
      }
    }

    if (this.props && this.props.isSubsection) {
      emitter.trigger('subsectionResizing', {
        subsectionHeight: this.ui.innerContent.offsetHeight,
        open: this.ui.content.classList.contains('is-visible'),
        parentId: this.el.dataset.parent,
      })
    }

    // set / remove required attributes for toggle form (ex: invoice address in create account)
    if (this.props && this.props.isForm) {
      getAll('[js-form-validation-field]', this.el).forEach(field => {
        if (field.getAttribute('required') == null) {
          field.setAttribute('required', true)
        } else {
          field.removeAttribute('required')
          field.value = ''
        }
      })
    }
  },

  scrollUp () {
    window.scrollBy({
      top: -this.ui.content.offsetHeight,
      left: 0,
      behavior: 'smooth',
    })
  },

  scrollUpConnected () {
    const offset = this.el.parentNode.offsetTop + this.el.offsetTop

    if (window.scrollY > offset) {
      window.scrollTo({
        top: offset,
        left: 0,
        behavior: 'smooth',
      })
    }
  },
})
